/**
 * Loads a script and runs the callback
 * @param  {[type]}   url      [description]
 * @param  {Function} callback [description]
 * @return {[type]}            [description]
 */

var urls = {}

function runCallbacks(callbacks) {
  var callback, i

  for (i = 0; i < callbacks.length; i++) {
    callback = callbacks[i]
    if (callback && typeof callback === 'function') {
      callback()
    }
  }
}

function loadScript(url, callback) {
  if (urls[url]) {
    if (urls[url] === 'loaded') {
      callback()
    } else {
      urls[url].push(callback)
    }
    console.log(url, 'is allready loaded')
    return
  }
  urls[url] = [callback]
  var script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState == 'loaded' || script.readyState == 'complete') {
        script.onreadystatechange = null
        try {
          runCallbacks(urls[url])
        } catch (e) {
          console.error(
            'Error calling callback for url',
            url,
            callback,
            e.message,
            e
          )
        }
      }
    }
  } else {
    script.onload = function () {
      try {
        runCallbacks(urls[url])
      } catch (e) {
        console.error(
          'Error calling callback for url',
          url,
          callback,
          e.message,
          e
        )
      }
    }
  }
  script.src = url
  ;(
    document.getElementsByTagName('head')[0] ||
    document.getElementsByTagName('body')[0]
  ).appendChild(script)
}

// http://stackoverflow.com/a/26808520/6848032
// first add raf shim
// http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
window.requestAnimFrame = (function () {
  return (
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 1000 / 60)
    }
  )
})()

// main function
function scrollToY(scrollTargetY, speed, easing) {
  // scrollTargetY: the target scrollY property of the window
  // speed: time in pixels per second
  // easing: easing equation to use

  var scrollY = window.scrollY || document.documentElement.scrollTop,
    scrollTargetY = scrollTargetY || 0,
    speed = speed || 2000,
    easing = easing || 'easeOutSine',
    currentTime = 0

  // min time .1, max time .8 seconds
  var time = Math.max(
    0.1,
    Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8)
  )

  // easing equations from https://github.com/danro/easing-js/blob/master/easing.js
  var easingEquations = {
    easeOutSine: function (pos) {
      return Math.sin(pos * (Math.PI / 2))
    },
    easeInOutSine: function (pos) {
      return -0.5 * (Math.cos(Math.PI * pos) - 1)
    },
    easeInOutQuint: function (pos) {
      if ((pos /= 0.5) < 1) {
        return 0.5 * Math.pow(pos, 5)
      }
      return 0.5 * (Math.pow(pos - 2, 5) + 2)
    },
  }

  // add animation loop
  function tick() {
    currentTime += 1 / 60

    var p = currentTime / time
    var t = easingEquations[easing](p)

    if (p < 1) {
      window.requestAnimFrame(tick)

      window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t)
    } else {
      window.scrollTo(0, scrollTargetY)
    }
  }

  // call it once to get started
  tick()
}

// http://stackoverflow.com/a/41839282/6848032
function closest(el, selector, stopSelector) {
  var retval = null
  while (el) {
    if (
      (el.msMatchesSelector && el.msMatchesSelector(selector)) ||
      (el.matches && el.matches(selector))
    ) {
      retval = el
      break
    } else if (stopSelector && el.className.indexOf(stopSelector) > -1) {
      break
    }
    el = el.parentElement
  }
  return retval
}

var throttle = function (type, name, obj) {
  if (!obj) {
    obj = window
  }

  var running = false
  var func = function () {
    if (running) {
      return
    }
    running = true
    requestAnimationFrame(function () {
      obj.dispatchEvent(new CustomEvent(name))
      running = false
    })
  }
  obj.addEventListener(type, func)
}

throttle('resize', 'optimizedResize')
